import { Controller, useFormContext } from 'react-hook-form'

interface ControlledHiddenFieldProps {
  name: string
}

export function ControlledHiddenField({ name }: ControlledHiddenFieldProps) {
  const { control } = useFormContext()

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => {
        return <input {...field} type='hidden' />
      }}
    />
  )
}
